import { atom } from 'jotai';
import { clearConeAtom, originAtom } from '@/features/glide';
import { clearSearchSelectionAtom, searchSelectionAtom } from '@/features/search';
import { appModeAtom, type AppMode } from './atoms';

/** Is there a cone or a search marker to clear? */
export const canClearAtom = atom((get) => get(originAtom) !== null || get(searchSelectionAtom) !== null);

/** Clears the computed cone and the search marker. */
export const clearAllAtom = atom(null, (_get, set) => {
  set(clearConeAtom);
  set(clearSearchSelectionAtom);
});

/** Switches forecast / explore. Forecast shows no cone, so leaving explore clears it. */
export const setAppModeAtom = atom(null, (_get, set, mode: AppMode) => {
  set(appModeAtom, mode);
  if (mode === 'forecast') set(clearConeAtom);
});
